export class ClientCodeResolver {
    constructor() {}
  
    static resolveClientFromUrl(host: string, pathname: string) {      
      const hostSegments = host.split(".");
      const pathSegments = pathname.split('/');
      let clientCode = '';
      let routerPathSegmentPrefix = '';
      const resolvedClientUrlType = resolveClientUrlType(hostSegments, pathSegments);

      switch (resolvedClientUrlType)    
      {
        case clientUrlType.consents:
          clientCode = pathSegments[1] || '';
          routerPathSegmentPrefix = clientCode.length === 0 ? '' : '/' + clientCode;
            break;
        case clientUrlType.localHost:
          clientCode = pathSegments[1] || '';
          routerPathSegmentPrefix = '/' + clientCode;
            break;
        case clientUrlType.depricatedConsents:
          clientCode = hostSegments[0] || '';
            break;
        case clientUrlType.depricatedLocalHost:
          clientCode = 'localhost';
            break;
      }
   
      return {
        clientCode: clientCode, 
        routerPathSegmentPrefix: routerPathSegmentPrefix, 
        clientUrltype: resolvedClientUrlType}
    }
  }

export function resolveClientUrlType(hostSegments: string[], pathSegments: string[]) {
  if (hostSegments[0] === 'connect' || hostSegments[0].startsWith('connect-consents-online')) {
    // USE CASE https://connect.consents.online/newobsignup/about
    return clientUrlType.consents;
  }
  else if (hostSegments[0] && hostSegments[0].startsWith('localhost:') && pathSegments.length > 2) {
    // USE CASE http://localhost:8080/newobsignup/about
    return clientUrlType.localHost;
  }
  else   if (hostSegments[0] && hostSegments[0].startsWith('localhost:')) {
    // USE CASE http://localhost:8080/about
    return clientUrlType.depricatedLocalHost;
  }
  else if (hostSegments.length >= 3) {
    if (hostSegments[1].startsWith('consents') || hostSegments[1].startsWith('accountscoreus') || hostSegments[1].startsWith('accountscore'))
    {
      // USE CASES https://newobsignup.consents.online/about - https://advanceamerica.accountscore.co.uk/about
      // USE CASES https://advanceamerica.accountscoreus.com/about - https://advanceamerica.accountscore.com/about
      return clientUrlType.depricatedConsents;
    }
  }
  return clientUrlType.notSupported;
}

export enum clientUrlType {
  consents = 0,
  localHost = 1,
  depricatedConsents = 3,
  depricatedLocalHost = 4,
  notSupported = 5,
}
